import { ChildProps } from '@apollo/client/react/hoc';
// TODO update this to import from commmons
// import { gql } from '@reverbdotcom/commons/src/gql';
// eslint-disable-next-line no-restricted-imports
import { gql } from '@apollo/client';
import React from 'react';
import I18n from 'i18n-js';

import { EUODRDetails, EUODRAddressFragment } from './eu_odr_details';
import ListingPaymentPolicies, { ListingPaymentPoliciesFragment } from './item2_listing_payment_policies';
import ListingShippingPolicies, { Item2ShopShippingPoliciesFragment } from './item2_listing_shipping_policies';
import ListingReturnPolicies, { Item2ShopReturnPoliciesFragment } from './item2_listing_return_policies';
import { IUserContext, withUserContext, IUser } from '@reverbdotcom/commons/src/components/user_context_provider';

import { isEU } from '../lib/geo';
import { Item2_Shop_PoliciesQuery } from '@reverbdotcom/commons/src/gql/graphql';
import Item2ShopTaxPolicies, { Item2ShopTaxPoliciesFragment } from './item2_shop_tax_policies';
import { RCLoadingBars } from '@reverbdotcom/cadence/components';
import { withGraphql } from '@reverbdotcom/commons/src/with_graphql';

interface ExternalProps extends IUserContext {
  listingId: string;
  fetchData: boolean;
}

type IProps = ChildProps<ExternalProps, Item2_Shop_PoliciesQuery>;

export const ShopPoliciesFragment = gql`
  fragment ShopPoliciesData on Listing {
    _id
    id
    ...Item2ListingPaymentPoliciesData
    ...Item2ShopShippingPoliciesData
    ...Item2ShopReturnPoliciesData
    ...Item2ShopTaxPoliciesData
  }
  ${ListingPaymentPoliciesFragment}
  ${Item2ShopShippingPoliciesFragment}
  ${Item2ShopReturnPoliciesFragment}
  ${Item2ShopTaxPoliciesFragment}
`;

interface ODRProps {
  listing: Item2_Shop_PoliciesQuery['listing'];
  user: IUser;
}

function RenderODRDetails(props: ODRProps) {
  const { shop } = props.listing;
  const { user } = props;

  if (!isEU(user.shippingRegionCode) || !shop.euOdrAddress) { return null; }

  return (
    <EUODRDetails
      shop={shop}
    />
  );
}

export function ShopPoliciesData(props: IProps) {
  if (!props.data || props.data.loading) {
    return (
      <div className="d-flex fx-align-center fx-justify-center height-vh-50">
        <RCLoadingBars size="large" />
      </div>
    );
  }
  const { listing } = props.data;
  const { user } = props;

  return (
    <>
      <h3
        className="size-120 scaling-mb-4"
      >
        {I18n.t('discovery.item2ShopPoliciesModal.acceptedPaymentMethods')}
      </h3>
      <ListingPaymentPolicies listing={listing} />
      <h3
        className="size-120 scaling-mb-4 scaling-mt-8"
      >
        {I18n.t('discovery.shopInfo.returnPolicy')}
      </h3>
      <ListingReturnPolicies listing={listing} />
      <h3
        className="size-120 scaling-mb-4 scaling-mt-8"
      >
        {I18n.t('discovery.item2ShopPoliciesModal.shippingOptions')}
      </h3>
      <ListingShippingPolicies listing={listing} />
      <Item2ShopTaxPolicies listing={listing} />
      <RenderODRDetails listing={listing} user={user} />
    </>
  );
}

const withQuery = withGraphql<IProps, Item2_Shop_PoliciesQuery>(
  gql`
    query Item2_Shop_Policies(
      $listingId: String
      $euUser: Boolean!
    ){
      listing(
        input: {id: $listingId}
      ){
        _id
        shop {
          _id
          uuid
          ...EUODRAddress @include(if: $euUser)
        }
        ...ShopPoliciesData
      }
    }
    ${ShopPoliciesFragment}
    ${EUODRAddressFragment}
  `,
  {
    skip: ownProps => !ownProps.fetchData,
    options: (ownProps) => {
      return {
        ssr: false,
        errorPolicy: 'all',
        variables: {
          listingId: ownProps.listingId,
          euUser: isEU(ownProps.user.shippingRegionCode),
        },
      };
    },
  },
);

export default withUserContext(withQuery(ShopPoliciesData));
